import {createSelector} from 'reselect';

import {getTeamsChannels} from '../data/channels/channelsSelectors';
import {getUserTeamParticipatingInboxes} from '../data/inboxes/inboxesSelectors';
import {getFlatTeammates} from '../data/teammates/teammatesSelectors';

export const getRuleParametersDependencies = createSelector(
  [getTeamsChannels, getUserTeamParticipatingInboxes, getFlatTeammates],
  (channels, inboxes, teammates) => ({
    channels,
    inboxes,
    teammates,

    integrations: {
      conditions: [],
      actions: [],
    },
  }),
);
